module.exports = __webpack_public_path__ + "img/undraw_studying_s3l7.1187bcc8.svg";